import { EntityBase } from "projects/sepidz-web-framework/src/lib/models/entity-base.model";

export class HrmLoanDeduct extends EntityBase {
  public HrmLoanToPersonnelId: number;
  public DeductPayMentYear: number;
  public DeductPayMentMonth: number;
  public DeductPayment: number;
  public DeductDescription: string;
  public GrpLoanToPersId?: number;
}
